export interface Product {
  id: string
  productNumber: string
  productName: string
  referenceTemperature: number
  inspectionsPerSample: number
  timeIntervalEnabled: boolean
  timeIntervalMinutes: number
  targetWeight: number
  createdAt: Date
}

export function createProduct(
  productNumber: string,
  productName: string,
  referenceTemperature: number,
  inspectionsPerSample: number,
  timeIntervalEnabled: boolean,
  timeIntervalMinutes: number,
  targetWeight: number,
): Product {
  return {
    id: Math.random().toString(36).substr(2, 9),
    productNumber,
    productName,
    referenceTemperature,
    inspectionsPerSample,
    timeIntervalEnabled,
    timeIntervalMinutes,
    targetWeight,
    createdAt: new Date(),
  }
}
